const React = require('react');

class Person extends React.Component {
    render() {
        const {person} = this.props;
        return(
            <section className="person">
                <img className="person__image" src={person.data.image} />
                <h2 className="person__name">{person.displayName}</h2>
                {person.data.title && <h3 className="person__title">{person.data.title}</h3>}
                <div className="person__contactInformation">
                    <ul>
                        {person.data.email && (
                        <li>
                            <a href={`mailto:${person.data.email}`}>{person.data.email}</a>
                        </li>
                        )}
                        {person.data.phone && (
                        <li>
                            <a href={`tel:${person.data.phone}`}>{person.data.phone}</a>
                        </li>
                        )}
                    </ul>
                </div>
            </section>
        )
    }
}

module.exports = Person;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Person/index.jsx